const S3Roots = {
  local: "https://public-dt-dev-dt-smooth-dt-jp.s3.ap-northeast-1.amazonaws.com",
  development: "https://public-dt-dev-dt-smooth-dt-jp.s3.ap-northeast-1.amazonaws.com",
  production: "https://public-dt-prod-dt-smooth-dt-jp.s3.ap-northeast-1.amazonaws.com",
  demo: "https://public-dt-dev-dt-smooth-dt-jp.s3.ap-northeast-1.amazonaws.com",
}

export const S3_ROOT = S3Roots[process.env.ENV_NAME as keyof typeof S3Roots] + "/smooth_for_cs"
